import announcementApi from './announcementApi';

const updateAnnouncement = async (id: number, announcementData: Record<string, unknown>) => {
  try {
    const { data } = await announcementApi({
      method: 'PUT',
      url: `/${id}`,
      data: announcementData,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[updateAnnouncement] Failed:', error);
    throw error;
  }
};

export default updateAnnouncement;
